import Keycloak from "keycloak-js";
import WSRODashboardProps from "../assets/props/wsro-props";

const KeyCloakClient = new Keycloak(WSRODashboardProps.keyCloak);

const KeyCloakProviderConfig = {
  onLoad: "login-required", // [ login-required | check-session | always | check-state ]
  redirectUri: WSRODashboardProps.keyCloak.redirectUri, // The redirect URI for the Keycloak server
  responseMode: "fragment", // [ query | fragment ]
  scope: "openid profile email", // [openid | profile | email | address | phone | offline_access]
  flow: "standard", //  [standard | implicit | hybrid]
  silentFlow: "silent-renew", // [silent-renew | none]
  silentRenew: true, 
  timeStep: 100000, // [in ms]
  checkLoginIframe: false, // [true | false]
};

export { KeyCloakClient, KeyCloakProviderConfig };
